import { useMemo } from 'react';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { useGetEmployeeDataQuery } from '@/modules/user/queries';
import { EmploymentStatus } from '@/modules/user/user.types';

interface Props {
  employeeId?: string;
}

export const buildFutureEmploymentHint = (activeEmploymentDate: string) =>
  `Dependent cards can be added on or after ${activeEmploymentDate}`;

export const useFutureDatedEmployee = ({ employeeId }: Props) => {
  const { rawData: employeeData } = useGetEmployeeDataQuery(employeeId);

  const effectiveFutureStatus = useMemo(
    () =>
      employeeData?.employment_statuses?.find((item) => item.status === EmploymentStatus.F && item.is_active),
    [employeeData?.employment_statuses]
  );

  const isFutureDatedEmployee = Boolean(effectiveFutureStatus);

  const activeEmploymentDate = useMemo(() => {
    const validTo = effectiveFutureStatus?.valid_to;
    const parsed = dayjs(validTo);
    return validTo && parsed.isValid() ? parsed.format(DEFAULT_DATE_FORMAT) : '';
  }, [effectiveFutureStatus?.valid_to]);

  const futureEmploymentHint = useMemo(
    () => buildFutureEmploymentHint(activeEmploymentDate),
    [activeEmploymentDate]
  );

  return {
    isFutureDatedEmployee,
    activeEmploymentDate,
    futureEmploymentHint,
  };
};
